import React from 'react'
import MHeroVideo1 from '../assets/video/mobile/mobile_KV01.mp4'
import THeroVideo1 from '../assets/video/tablet/tablet_KV01.mp4'
import DHeroVideo1 from '../assets/video/desktop/desktop_KV01.mp4'
import MHeroVideo2 from '../assets/video/mobile/mobile_KV02.mp4'
import THeroVideo2 from '../assets/video/tablet/tablet_KV02.mp4'
import DHeroVideo2 from '../assets/video/desktop/desktop_KV02.mp4'
import RenderVideo from './RenderVideo'
import ScrollBtn from '../components/ScrollBtn'

// whereToScroll prop is a element ID to scroll
const HomeHero = ({ whereToScroll }) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return (
    <div className='hero-video relative z-[5]'>
      {timezone.includes('Europe' || 'europe') ? (
        <>
          <RenderVideo
            id='homeVideo'
            videoM={MHeroVideo2}
            videoT={THeroVideo2}
            videoD={DHeroVideo2}
            classList={
              'max-w-[1920px] lg:left-1/2 lg:-translate-x-1/2 absolute object-cover h-full w-screen -z-[1] overflow-hidden'
            }
          />
        </>
      ) : (
        <>
          <RenderVideo
            id='homeVideo'
            videoM={MHeroVideo1}
            videoT={THeroVideo1}
            videoD={DHeroVideo1}
            classList={
              'max-w-[1920px] lg:left-1/2 lg:-translate-x-1/2 absolute object-cover h-full w-screen -z-[1] overflow-hidden'
            }
          />
        </>
      )}

      <div className='left-1/2 -translate-x-1/2 container h-full absolute flex flex-col justify-end text-center overflow-hidden'>
        <h1 className='lg:px-[80px] lg:w-full lg:absolute lg:top-1/2 lg:left-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2 lg:text-8xl lg:text-white lg:opacity-[0.75] md:text-7xl md:mb-[40px] text-3xl mb-[24px]'>
          Get the whole image™
        </h1>
        <p className='text-lg px-[5px]'>
          Automate your car photography and inspection with AI.
        </p>
        <p className='md:mb-[25px] text-lg mb-[85px] px-[5px]'>
          See more with Vumo.
        </p>
        <ScrollBtn to={whereToScroll} />
      </div>
    </div>
  )
}

export default HomeHero
